module.exports = __webpack_public_path__ + "static/media/zoom-map.0ec59cec.png";